import { useDispatch, useSelector } from "react-redux";

import { dropdownValuesActions } from "store";

// This one is not handled by useDDLValues
// as it fetches 2 arguments with single query and then returns both
export function useTerminals() {
	const dispatch = useDispatch();
	const terminalManufacturers = useSelector<any, any[]>(
		state => state.dropdownValues.terminalManufacturers,
	);
	const terminalModels = useSelector<any, any[]>(
		state => state.dropdownValues.terminalModels,
	);
	const terminalDeviceTypes = useSelector<any, any[]>(
		state => state.dropdownValues.terminalDeviceTypes,
	);
	const terminalAccessoryTypes = useSelector<any, any[]>(
		state => state.dropdownValues.terminalAccessoryTypes,
	);

	const terminalManufacturersLoading = useSelector<any, boolean>(
		state => state.dropdownValues.loading.terminalManufacturers,
	);
	const terminalModelsLoading = useSelector<any, boolean>(
		state => state.dropdownValues.loading.terminalModels,
	);
	const terminalDeviceTypesLoading = useSelector<any, boolean>(
		state => state.dropdownValues.loading.terminalDeviceTypes,
	);
	const terminalAccessoryTypesLoading = useSelector<any, boolean>(
		state => state.dropdownValues.loading.terminalAccessoryTypes,
	);

	const terminalManufacturersError = useSelector<any, boolean>(
		state => state.dropdownValues.error.terminalManufacturers,
	);
	const terminalModelsError = useSelector<any, boolean>(
		state => state.dropdownValues.error.terminalModels,
	);
	const terminalDeviceTypesError = useSelector<any, boolean>(
		state => state.dropdownValues.error.terminalDeviceTypes,
	);
	const terminalAccessoryTypesError = useSelector<any, boolean>(
		state => state.dropdownValues.error.terminalAccessoryTypes,
	);

	if (
		(!terminalManufacturers?.length &&
			!terminalManufacturersLoading &&
			!terminalManufacturersError) ||
		(!terminalModels?.length &&
			!terminalModelsLoading &&
			!terminalModelsError) ||
		(!terminalDeviceTypes?.length &&
			!terminalDeviceTypesLoading &&
			!terminalDeviceTypesError) ||
		(!terminalAccessoryTypes &&
			!terminalAccessoryTypesLoading &&
			!terminalAccessoryTypesError)
	) {
		dispatch(dropdownValuesActions.getTerminals());
	}

	return {
		terminalManufacturers,
		terminalModels,
		terminalDeviceTypes,
		terminalAccessoryTypes,
		terminalManufacturersLoading,
		terminalModelsLoading,
		terminalDeviceTypesLoading,
		terminalAccessoryTypesLoading,
		terminalManufacturersError,
		terminalModelsError,
		terminalDeviceTypesError,
		terminalAccessoryTypesError,
	};
}
